import React, { createContext, useState, useContext } from "react";

const AmbienteContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaAmbiente_id, setEnergiaAmbiente_id] = useState();

  return (
    <AmbienteContext.Provider value={{ energiaAmbiente_id, setEnergiaAmbiente_id }} >
      {children}
    </AmbienteContext.Provider>
  );
}

export function useAmbienteContext() {
  const context = useContext(AmbienteContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaAmbiente_id, setEnergiaAmbiente_id } = context;
  return { energiaAmbiente_id, setEnergiaAmbiente_id };
}

